export interface ReturnsSettingsExperienceInput {
  isRedoUser: boolean;
  teamInRollout: boolean;
  requiredForRedoUsers: boolean;
}

export function resolveReturnsSettingsExperience({
  isRedoUser,
  teamInRollout,
  requiredForRedoUsers,
}: ReturnsSettingsExperienceInput): { useNewUi: boolean } {
  return { useNewUi: teamInRollout || (isRedoUser && requiredForRedoUsers) };
}
